module.exports = __webpack_public_path__ + "static/media/m_beard_scruff_diamond__v_shadow.569ad864.png";